module.exports = __webpack_public_path__ + "static/media/SKInteracEng_white.4a336912.png";